import { getJSON } from 'bv-fetch';

export default () => getJSON('/bv_api/live_chat_settings');
